module.exports = __webpack_public_path__ + "static/img/flash_sale_bg.0ce5058d.png";